import React from 'react';
import BeatLoader from 'react-spinners/BeatLoader';

export enum CustomSpinnerColor {
  PrimaryMagenta = 'primaryMagenta',
  ProGold = 'proGold',
  White = 'white',
}

interface CustomSpinnerProps {
  color: CustomSpinnerColor;
  size?: number;
  style?: React.CSSProperties;
}

const COLOR_MAPPER = {
  primaryMagenta: '#f32a52',
  proGold: '#c5a26d',
  white: '#fff',
};

const CustomSpinner = ({ color, size = 10, style }: CustomSpinnerProps) => {
  return <BeatLoader color={COLOR_MAPPER[color]} size={size} style={style} />;
};

export default CustomSpinner;
